export const mathJaxConfig = {
  loader: {
    load: ["[tex]/ams"],
    options: {
      enableAssistiveMml: true,
    },
  },
  tex: {
    packages: { "[+]": ["ams"] },
    inlineMath: [
      ["$", "$"],
      ["\\(", "\\)"],
    ],
    displayMath: [
      ["$$", "$$"],
      ["\\[", "\\]"],
    ],
    processEscapes: true,
    processEnvironments: true,
  },
  startup: {
    typeset: true,
  },
};
